import type { StaffRole } from '@ucp/web/lib';

/**
 * Roles that get the Service Operations workbench (PRO-1350 Epic 6, D37).
 * Oversight is US15 metrics — not this surface. L6 is deliberately absent (ADR-018).
 */
export const SERVICE_OPS_PEOPLE_ROLES: readonly StaffRole[] = [
  'SERVICE_OPS_PEOPLE_OWNER',
  'SERVICE_OPS_PEOPLE_OPERATOR',
];

export const SERVICE_OPS_FINANCE_ROLES: readonly StaffRole[] = [
  'SERVICE_OPS_FINANCE_OWNER',
  'SERVICE_OPS_FINANCE_OPERATOR',
];
